const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/privacy.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/{-$locale}/privacy")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});